import { InternalServerErrorException } from '../../../../common/exceptions/exceptions';
import { LogManager } from '../../../../common/port/log/log.manager.port';
import { AccountAverageCallsPerPersonSummaryAggregateRootMapper } from '../../../../infrastructure/mappers/org-metrics/calls/account-average-calls-per-person-summary.aggregate-root.mapper';
import { GetAccountAverageCallsPerPersonSummaryRequestDto } from '../../../dtos/org-metrics/calls/get-account-average-calls-per-person-summary.request.dto';
import { GetAccountAverageCallsPerPersonSummaryResponseDto } from '../../../dtos/org-metrics/calls/get-account-average-calls-per-person-summary.response.dto';
import { GetAccountAverageCallsPerPersonSummaryQuery } from '../../../queries/org-metrics/calls/get-account-average-calls-per-person-summary.query';

export class GetAccountAverageCallsPerPersonSummaryController {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly query: GetAccountAverageCallsPerPersonSummaryQuery,
    protected readonly mapper: AccountAverageCallsPerPersonSummaryAggregateRootMapper
  ) {}

  async get(
    props: GetAccountAverageCallsPerPersonSummaryRequestDto
  ): Promise<GetAccountAverageCallsPerPersonSummaryResponseDto> {
    try {
      const result = await this.query.execute(props);
      return this.mapper.toResponse(result);
    } catch (error) {
      throw new InternalServerErrorException(
        `GetAccountAverageCallsPerPersonSummaryController.get encountered an error ${error}`
      );
    }
  }
}
